import { render, staticRenderFns } from "./ClickEdit.vue?vue&type=template&id=0019af18&scoped=true&"
import script from "./ClickEdit.vue?vue&type=script&lang=js&"
export * from "./ClickEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClickEdit.vue?vue&type=style&index=0&id=0019af18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0019af18",
  null
  
)

export default component.exports